import React from "react";
import { Outlet } from "react-router";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "../../css/component.css";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="Layout">
      <input type="checkbox" id="sidebar_toggel" />
      <Sidebar />
      <main className="main_content">
        <Navbar />
        <Outlet />
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
